/* Copyright (c) 2019-2021, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Subject } from 'rxjs';
import { BrowserDbUpdateMessage } from './models';

/**
 * Used to share information between plugins
 */
export const PluginMessages = new Subject();
export const SharedStorageUpdateMessages = new Subject<BrowserDbUpdateMessage>();
